<!-- 服务人员状态管理 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex flexAi-c">
        <div class="text">服务人员管理</div>
        <el-button @click="addStatusBut" round type="primary" size="small"
          >添加服务人员</el-button
        >
      </div>
      <div class="content">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="ServiceList.list"
          style="width: 100%"
        >
          <el-table-column prop="id" label="#"> </el-table-column>
          <el-table-column prop="tel" label="手机号"> </el-table-column>
          <el-table-column prop="servername" label="姓名"> </el-table-column>
          <el-table-column prop="serviceSpecialize" label="擅长领域"> </el-table-column>

          <el-table-column label="状态">
            <template slot-scope="scope">
              {{ scope.row.free | filterNum('空闲', '工作中') }}
            </template>
          </el-table-column>
          <el-table-column label="正在执行订单">
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.free == 0"
                :underline="false"
                type="primary"
                >---</el-link
              >
              <el-link
                v-else
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >查看</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="工作报表">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="statementBut(scope.row)"
                >查看</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="变为普通用户">
            <template slot-scope="scope">
              <el-popconfirm
                @confirm="alterStateBut(scope.row)"
                title="是否更改为普通用户？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >更改</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >编辑</el-link
              >
              <!-- <el-popconfirm
                style="padding-left:10px"
                @confirm="delBut(scope.row)"
                title="删除后无法找回，确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm> -->
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                @confirm="delBut(scope.row)"
                title="这是一段内容确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ ServiceList.total }}条记录，</span>
            <span class="pageNum">{{ ServiceList.pageNum }}</span>
            <span>/{{ ServiceList.pages }}页</span>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="ServiceList.pageNum"
            :page-size="ServiceList.pageSize"
            layout="prev, pager, next, jumper"
            :total="ServiceList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiGetServiceList,
  apiChangeServerToUsers,
  apiDelServer,
  apiGetDaily
} from '@/api/management'

export default {
  name: '',
  props: [''],
  data() {
    return {
      ServiceList: [], // 列表
      pages: {
        page: 1, // 页数
        size: 20
      },
      dialogTitle: '',
      isEdit: false, // 判断是否为修改管理员
      adId: '', // 管理员id
      UserForm: {
        tel: '',
        password: '',
        servername: '',
        serviceSpecialize: '',
        image: '',
        server: '',
        anworktime: ''
      },
      adminFormEmail: '',
      adminFormList: ['姓名不能为空！', '手机账号不能为空！', '密码不能为空！']
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetServiceList()
  },

  methods: {
    // 新增管理员
    addStatusBut() {
      this.$router.push({
        path: '/AddPersonnelStatus'
      })
    },
    // 变为普通用户
    alterStateBut(row) {
      apiChangeServerToUsers({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetServiceList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 工作报表
    statementBut(row) {
      apiGetDaily({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$alert(`今日接单数：${res.data}`, '', {
            confirmButtonText: '确定'
          })
        }
      })
      // this.$router.push({
      //   path: '/report',
      //   query: {
      //     info: this.$Base64.encode(JSON.stringify(row))
      //   }
      // })
    },
    // 列表删除
    delBut(row) {
      apiDelServer({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetServiceList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
      console.log(row)
    },
    // 列表修改
    editBut(row) {
      console.log(row)
      this.$router.push({
        path: '/AddPersonnelStatus',
        query: {
          info: this.$Base64.encode(JSON.stringify(row))
        }
      })
    },

    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetServiceList()
    },
    // 接口
    // 获取服务人员的列表
    GetServiceList() {
      apiGetServiceList({
        page: this.pages.page,
        pageSize: this.pages.size
      }).then(res => {
        if (res.status === 0) {
          this.ServiceList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 52px;
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    height: calc(100vh - 172px);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-table {
      overflow: auto;
      height: calc(100vh - 224px);
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
